<template>
	<div id="main">
		{{ showfalse ? errmsg : '' }}
	</div>
</template>

<script>
	import { login } from "@/api/index";
	import router from '@/router';
	export default {
		data() {
			return {
				loginForm:{
					account:"qadmin",
					password:"123456",
				},
				imei: '',
				showfalse: false,
				errmsg: ''
			}
		},
		computed: {
		},
		components: {
		},
		mounted() {
			this.user_login()
		},
		methods: {
			user_login(){	
				let params = {
					username: this.loginForm.account,
					password: this.loginForm.password,
					keep:true,
				};
				login(params).then((res) => {
					if (res.code == 1) {
						sessionStorage.setItem("token", res.data.userInfo.token);
						localStorage.setItem("HomeState","0");
						localStorage.setItem("userInfor",JSON.stringify(res.data.userInfo));
						localStorage.setItem("token",res.data.userInfo.token);			
						router.push({name:'home'});
						setTimeout(() => {
							window.location.reload();
						}, 500)
					} else {
						this.showfalse = true
						this.errmsg = res.msg
					}
				});				
			},
		},
		beforeDestroy() {

		},

	}
</script>

<style scoped>
</style>
